import {Directive, TemplateRef} from '@angular/core'

@Directive({
  selector: '[list-item-header]',
  standalone: false,
})
export class FilterListItemHeaderDirective {
  constructor(private tpl: TemplateRef<any>) {}
}
